import React, { useCallback } from "react";
import { connect } from "react-redux";
import utils from "../../app/UtilityService";
import translationService from "../../app/TranslationService";
import internalStateService from "../../app/InternalStateService";
import { ReduxControlMessages } from "../control-messages/ControlMessages";

export const Messages = (props) => {
    const onClose = useCallback(() => {
        props.dismissMessages();
        // always get action from cancelButton first
        let button = props.cancelButton || props.closeButton || {};
        triggerActions(button.action);
    }, [props]);

    const onAccept = useCallback(() => {
        props.dismissMessages();
        let button = props.confirmButton || {};
        triggerActions(button.action);
    }, [props]);

    const triggerActions = (action) => {
        if (action) {
            action();
        }
    };

    const getApplicationConfigByType = useCallback((type) => {
        let projectComponentConfig =
            internalStateService.getComponentsDefaultConfig()["applicationMessage"] || [];

        let result = projectComponentConfig.filter((config) => config.type === type);

        if (result.length) {
            return result[0];
        }

        return {};
    }, []);

    const getConfig = useCallback(() => {
        let content = props.content || [];
        let closable = props.closable || false;

        let projectConfig = {};
        let projectButtons = {};
        let entityType = "info";
        //check if there is just entities of one type
        content.forEach((entity) => {
            entityType = entity.type;
            projectConfig = getApplicationConfigByType(entityType);
            projectButtons = projectConfig.actions || {};
        });
        let config = {};
        const buttons = ["confirmButton", "closeButton", "cancelButton"];
        //check for presentation coming from server
        const serverPresentation = Object.keys(props).filter((key) => {
            if (buttons.includes(key) && props[key].presentation) {
                return true;
            }
            return false;
        });
        //if no server presentation continue with project presentation configuration
        //merge server actions with project presentation configuration
        if (!serverPresentation.length) {
            let presentationAndActions = Object.keys(projectButtons)
                .filter((key) => buttons.includes(key))
                .reduce((object, key) => {
                    if (key === "cancelButton") {
                        closable = true;
                    }
                    object[key] = Object.assign({}, props[key], projectButtons[key]);
                    return object;
                }, {});
            config = Object.assign({}, props, presentationAndActions);
            return {
                visualizationLayer: "modal",
                type: "controlMessages",
                children: [
                    {
                        type: "controlMessagesGroup",
                        bindTo: `{parent}.${entityType}`,
                        closable: closable,
                        groupType: entityType
                    }
                ],
                ...config
            };
        }

        let buttonsConfig = Object.assign({}, props);
        for (let key in projectButtons) {
            if (props[key] && props[key].presentation) {
                let projectPresentation = projectButtons[key].presentation || {};
                let serverPresentation = props[key].presentation || {};
                let buttonProperties = Object.assign({}, projectPresentation, serverPresentation);
                buttonsConfig[key].presentation = buttonProperties;
            } else if (props[key]) {
                delete buttonsConfig[key];
            }
        }
        if (buttonsConfig.hasOwnProperty("closeButton")) {
            closable = true;
        }
        return {
            type: "controlMessages",
            visualizationLayer: "modal",
            children: [
                {
                    type: "controlMessagesGroup",
                    bindTo: `{parent}.${entityType}`,
                    closable: closable,
                    groupType: entityType
                }
            ],
            ...buttonsConfig
        };
    }, [props, getApplicationConfigByType]);

    const buildEntities = useCallback((content) => {
        return content.map((entity) => {
            let message = entity.messages;
            if (Array.isArray(message)) {
                message = entity.messages[0];
            }
            return {
                class: [entity.type],
                properties: {
                    name: entity.title
                },
                entities: [
                    {
                        properties: { value: message }
                    }
                ]
            };
        });
    }, []);

    if (props.opened) {
        let content = props.content || [];
        let entities = buildEntities(content);
        let config = getConfig();
        let appMsgProps = {
            config,
            data: {
                entities,
                properties: { dataTqId: "GlobalMessage" }
            }
        };
        //Compute label-input container class
        let containerClass = props.extraClasses || "";
        appMsgProps.config.extraClasses = containerClass + " tq-global-notifications";

        if (appMsgProps.config.hasOwnProperty("cancelButton")) {
            let presentation = appMsgProps.config.cancelButton.presentation || {};
            if (presentation) {
                appMsgProps.config.closeLabel =
                    presentation.label || translationService.translate("no");
                appMsgProps.onClose = onClose;
            }
        }
        if (appMsgProps.config.hasOwnProperty("confirmButton")) {
            let presentation = appMsgProps.config.confirmButton.presentation || {};
            if (presentation) {
                appMsgProps.config.acceptLabel =
                    presentation.label || translationService.translate("yes");
                appMsgProps.onAccept = onAccept;
            }
        }
        if (appMsgProps.config.hasOwnProperty("closeButton") || props.closable) {
            //let presentation = props.config.closeButton.presentation || {};
            // if (presentation) {
            //     props.onClose = this.onClose;
            // }
            appMsgProps.onClose = onClose;
        }

        return <ReduxControlMessages {...appMsgProps} />;
    }

    return <></>;
};

function mapStateToProps(state, ownProps) {
    let messages = state.getIn(["messages"]);
    if (messages) {
        return Object.assign({}, ownProps, messages.toJS());
    }
    return ownProps;
}

Messages.displayName = "Messages"; //minification concern

export default connect(
    mapStateToProps,
    utils.getMapDispatchToProps({
        dismissMessages: "messages.dismissMessages"
    })
)(Messages);
